import type { Imputation } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const url = '/api/finances/comptabilite/imputations';

export const searchImputations = (params: URLSearchParams) =>
	request.get<any, TemplateRequestGet<Imputation>>(
		`${url}/search?${params.toString()}`,
	);
